import { Component, OnInit, OnDestroy, ViewChild, ViewChildren } from '@angular/core';

// COMPONENTS
import { CustomTicketItemArray } from '../../models/domain/custom.ticket.item';
import { ssApiService } from '../../services/ss-api.service';
import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { Subscription } from 'rxjs';
import { GlobalService } from '../../services/global.service';
import { MemberVersionsComponent } from 'app/shared/components/member.versions/member.versions.component';
import { QueryList } from '@angular/core';
import { ProductsOverviewComponent } from 'app/shared/components/products.overview/products.overview.component';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit, OnDestroy {

    // VARIABLES
    IsBusy: boolean = false;
    UnclaimedIncludeClosed: boolean = false;
    TicketSubscription: Subscription;
    ArchiveDate: Date;

    @ViewChildren(MemberVersionsComponent) memberVersions: QueryList<MemberVersionsComponent>;
    @ViewChild(ProductsOverviewComponent) memberProducts: ProductsOverviewComponent;

    public Widgets: CustomTicketItemArray = new CustomTicketItemArray();

    constructor(public api: ssApiService, private gb: GlobalService) { }

    ngOnInit() {
        this.gb.SetPageTitle('Dashboard');

        var initDate = new Date();
        initDate.setHours(0,0,0,0);        

        this.ArchiveDate = initDate;

        this.LoadTickets();
        this.TicketSubscription = this.api.loadTickets().subscribe( response => {
            this.LoadTickets();
        });
    }

    ArchiveDateChanged($event){
        //this.legacy.GetMemberVersions();
        this.ArchiveDate = $event;

        var minDate = new Date(2022, 10, 28, 0, 0, 0, 0);
        var maxDate = new Date();
        maxDate.setHours(0,0,0,0);  

        if (this.ArchiveDate < minDate){
            console.log("minDate", this.ArchiveDate);
            this.ArchiveDate = minDate;
        }

        if (this.ArchiveDate > maxDate){
            console.log("maxDate", this.ArchiveDate);
            this.ArchiveDate = maxDate;
        }

        this.memberVersions.forEach((child) => { child.archiveDate = this.ArchiveDate; child.GetMemberVersions(); })

        this.memberProducts.archiveDate = this.ArchiveDate;
        this.memberProducts.GetProductTotals();
    }

    ngOnDestroy() {
        this.TicketSubscription.unsubscribe();
    }

    LoadTickets() {
        let subscription = this.api.GetCustomTicketsUnclaimed(this.UnclaimedIncludeClosed).subscribe(
            async (result: IBaseResponse<CustomTicketItemArray>) => {
                subscription.unsubscribe();

                if (!result.Result) {
                    this.IsBusy = false;
                    console.log('Error', result.Message);
                    return;
                }

                this.Widgets = result.Data;
                // this.Totals = result.Data.Totals;
                // this.UnclaimedTicketsCount = result.Data.NotAssigned;

                this.IsBusy = false;
            }, (error: any) => {
                subscription.unsubscribe();
                this.IsBusy = false;
            }
        );
    }


}
